module.exports = "mutation UpdateStorefrontMugshot {\n  updateStorefrontMugshot {\n    storefront {\n      ...StorefrontFragment\n    }\n  }\n}\n"